/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticketsinvoicesaved2Inputs */

const en_ticketsinvoicesaved2 = /** @type {(inputs: Ticketsinvoicesaved2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saved`)
};

const de_ticketsinvoicesaved2 = /** @type {(inputs: Ticketsinvoicesaved2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gespeichert`)
};

/**
* | output |
* | --- |
* | "Saved" |
*
* @param {Ticketsinvoicesaved2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketsinvoicesaved2 = /** @type {((inputs?: Ticketsinvoicesaved2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketsinvoicesaved2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketsinvoicesaved2(inputs)
	return de_ticketsinvoicesaved2(inputs)
});
export { ticketsinvoicesaved2 as "ticketsInvoiceSaved" }